import React, { Component } from 'react';
import '../sass/App.css'; // App.scss
import { Switch,Route } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Home } from './home/';
import Service from './service/';
// import Works from '../container/works';
import Contact from '../container/contact';
import ContactResult from './contact/result';
import ContactError from './contact/error';
import CompanyList from './CompanyList';
import Company from './company/';
import PrivacyPolicy from './privacypolicy/';
import Recruit from '../container/recruit';
import Error404 from './error404/';
import Footer from './Footer';
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


class App extends Component {
  
  render() {
    return (
      
      <div className="App">
        <Navbar />
          <Switch>
            <Route key="home" exact path='/' component={Home} />
            <Route key="service" path='/service' component={Service} />
            {/* <Route key="works" path='/works' component={Works} /> */}
            <Route key="contact" exact path='/contact' component={Contact} />
            <Route key="contactResutl" path='/contact/result' component={ContactResult} />
            <Route key="contactResutl" path='/contact/error' component={ContactError} />
            <Route key="company" path='/company' component={Company} />
            <Route key="recruit" path='/recruit' component={Recruit} />
            <Route key="privacypolicy" path='/privacypolicy' component={PrivacyPolicy} />
            <Route key="error404" path="*" component={Error404} />
          </Switch>
            <CompanyList />
          <Footer />
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/component/App.js